<template>
  <div>WishList</div>
</template>

<script>
export default {

  name: 'WishList',

  data() {
    return {

    };
  },
};
</script>
